import { useEffect, useRef, useState } from "react";
import { useGeneralContext } from "../../General/Context";
import { useHistory } from "react-router-dom";
import { InterviewService } from "../../../services/InterviewService";
import { jobRoleService } from "../../../services/JobRoleService";
import { useTranslation } from "react-i18next";
import { showWarning } from "../../../services/ModalService";
import { toDateString } from "../../../common/helper";
import { toast } from "react-toastify";
import { InterviewExportButton } from "../InterviewExportButton";
import SortedHeader from "../../../components/Tables/SortedHeader";
import IconStar from "../../../layout/others/icon_star_idle_yellow.svg";
import Pagination from "../../../components/Pagination";
import { ReactComponent as IconExclamation } from "../../../layout/others/icon_alert_exclamation.svg";
import { ReactComponent as ScreenCallIcon } from "../../../layout/other_icons/ScreenCall_icon.svg";
import IconThreeDots from "../../../layout/others/three-dots.svg";
import GreenCircle from "../../../layout/icons_status/icon_status_active.svg";
import YellowCircle from "../../../layout/icons_status/icon_status_inactive.svg";
import GrayCircle from "../../../layout/icons_status/icon_status_default.svg";
import BlueCircle from "../../../layout/icons_status/icon_status_ia.svg";
import moment from "moment";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";
import "bootstrap/dist/js/bootstrap.bundle";
import IconValid from "../../../layout/others/valid-check-icon.svg";
import DynamicTableEditor from "../../../components/Tables/DynamicTableEditor";
import InterviewListFilters from "./interviewListFilters";
import SideDrawerSearch from "../../../components/SideDrawerSearch";

export default function InterviewListPage(props) {
  const [isFiltersOpen, setIsFilterOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState();
  const { userInformation } = useGeneralContext();
  const { t } = useTranslation();
  const FIRSTPAGE = 1;
  const [pageSize, setPageSize] = useState(10);
  const [interview, setInterview] = useState([]);
  const [totalPages, SetTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  //const INTERVIEW = 1;
  const [searchObject, setSearchObject] = useState({
    orderby: "Date",
    order: 1,
    availabilityStatus: [],
    skills: []
  });
  const [listExportDownloadStatus, setListExportDownloadStatus] = useState({
    statusName: "done",
    errorCaught: false
  });
  const format = { excel: 0, pdf: 1 };
  const [isInterviewsLoading, setIsInterviewsLoading] = useState(true);
  const [headers, setHeaders] = useState([]);

  function changeColumns(data) {
    let _headers = [];
    _headers.push({
      label: "",
      field: "CandidateState",
      key: "CandidateState",
      style: { width: "1%" }
    });
    data.forEach((item) => {
      if (item.key === "rating") {
        _headers.push({
          label: t(item.columnName),
          field: "Rating",
          title: t(item.columnName),
          key: item.key,
          style: { paddingRight: "5px" }
        });
      } else if (item.key === "name") {
        _headers.push({
          label: t(item.columnName),
          field: "Name",
          key: item.key,
          title: t(item.columnName),
          style: { paddingLeft: "5px" }
        });
      } else if (item.key === "jobRole") {
        _headers.push({
          label: t(item.columnName),
          field: "JobRole",
          key: item.key,
          title: t(item.columnName),
          style: { paddingLeft: "5px" }
        });
      } else if (item.key === "availability") {
        _headers.push({
          label: t(item.columnName),
          title: t(item.columnName),
          key: item.key,
          style: { paddingRight: "10px", paddingLeft: "22px" }
        });
      } else if (item.key === "salaryExpected") {
        _headers.push({
          label: t(item.columnName),
          field: "SalaryExpected",
          title: t(item.columnName),
          key: item.key,
          style: { paddingLeft: "20px" }
        });
      } else if (item.key === "managerName") {
        _headers.push({
          label: t(item.columnName),
          field: "ManagerName",
          title: t(item.columnName),
          key: item.key,
          style: { paddingLeft: "10px" }
        });
      } else if (item.key === "needDocumentation") {
        _headers.push({
          label: t(item.columnName),
          field: "needDocumentation",
          title: t(item.columnName),
          key: item.key
        });
      } else if (item.key === "englishLevel") {
        _headers.push({
          label: item.columnName,
          title: t(item.columnName),
          key: item.key,
          style: { paddingRight: "10px" },
          icon: () => <span class="fi fi-gb fis"></span>
        });
      } else if (item.key === "spanishLevel") {
        _headers.push({
          label: item.columnName,
          title: t(item.columnName),
          key: item.key,
          style: { paddingRight: "10px" },
          icon: () => <span class="fi fi-es fis"></span>
        });
      } else if (item.key === "frenchLevel") {
        _headers.push({
          label: item.columnName,
          title: t(item.columnName),
          key: item.key,
          style: { paddingRight: "10px" },
          icon: () => <span class="fi fi-fr fis"></span>
        });
      } else if (item.key === "dutchLevel") {
        _headers.push({
          label: item.columnName,
          title: t(item.columnName),
          key: item.key,
          style: { paddingRight: "10px" },
          icon: () => <span class="fi fi-nl fis"></span>
        });
      } else if (item.key === "languageLevel") {
        _headers.push({
          label: t(item.columnName),
          field: "LanguageLevel",
          title: t(item.columnName),
          key: item.key,
          style: { paddingLeft: "10px" }
        });
      }else if (item.key === "yearsExperience") {
        _headers.push({
          label: item.columnName,
          title: t(item.columnName),
          key: item.key,
          style: { paddingLeft: "10px" }
        });
      }
       else if (item.key === "skills") {
        _headers.push({
          label: t(item.columnName),

          key: item.key,
          title: t(item.columnName),
          style: { paddingLeft: "5px" }
        });
      } else if (item.key === "date") {
        _headers.push({
          label: t(item.columnName),
          field: "Date",
          key: item.key,
          title: t(item.columnName),
          //  sorted: true,
          style: { paddingLeft: "5px" }
        });
      } else if (item.key === "numberOfInterviews") {
        _headers.push({
          label: t(item.columnName),
          field: "NumberOfInterviews",
          title: t(item.columnName),
          key: item.key,
          style: { paddingLeft: "10px" }
        });
      } else if (item.key === "name") {
        _headers.push({
          label: t(item.columnName),
          field: "Name",
          key: item.key,
          title: t(item.columnName),
          style: { paddingLeft: "5px" }
        });
      } else if (item.key === "technologies") {
        _headers.push({
          label: t(item.columnName),
          key: item.key,
          title: t(item.columnName),
          style: { paddingLeft: "5px" }
        });
      } else if (item.key === "currentLocation") {
        {
          _headers.push({
            label: t(item.columnName),

            key: item.key,
            title: t(item.columnName),
            style: { paddingLeft: "5px" }
          });
        }
      } else {
        _headers.push({
          label: t(item.columnName),
          field: item.key[0].toUpperCase() + item.key.slice(1),
          key: item.key,
          title: t(item.columnName),
          style: { paddingLeft: "5px" }
        });
      }
    });
    _headers.push({ label: "", key: "actions" });
    setHeaders(_headers);
  }

  const [canPageLoad, setCanPageLoad] = useState(false);
  const [canExport, setCanExport] = useState(false);
  const [enableClearFilters, setEnableClearFilters] = useState(false);

  useEffect(() => (document.title = t("AtVitae - Interviews")), [t]);

  function handlePostMessage(event) {
    if (
      event.data === "INTERVIEWLISTREFRESH" &&
      event.origin === window.location.origin
    ) {
      getInterviews(searchObject);
    }
  }

  useEffect(() => {
    window.addEventListener("message", handlePostMessage);

    return () => window.removeEventListener("message", handlePostMessage);
  }, []);

  useEffect(() => {
    (async () => {
      const data = await jobRoleService.getRoles();

      const urlParams = new URLSearchParams(window.location.search);
      const urlSearchObjectParams = Object.fromEntries(urlParams.entries());

      var path = window.location.pathname.split("/");
      if (path.length >= 4) {
        let newSearchObject = { ...searchObject };
        setPageNumber(Number(path[3]));
        setPageSize(Number(path[2]));

        if (Object.keys(urlSearchObjectParams).length > 0) {
          Object.keys(urlSearchObjectParams).forEach((key) => {
            if (key === "startingDate" || key === "endingDate") {
              newSearchObject[key] = moment(
                urlSearchObjectParams[key]
              ).toDate();
            } else if (key === "recommended") {
              newSearchObject[key] = urlSearchObjectParams[key] === "true";
            } else {
              newSearchObject[key] = urlSearchObjectParams[key];
            }
          });
          setSearchObject(newSearchObject);
        }
        replacePreviousInterview(
          Number(path[2]),
          Number(path[3]),
          newSearchObject
        );

        setCanPageLoad(true);
      } else {
        await getInterviews(searchObject);
        setCanPageLoad(true);
      }
    })();
  }, []);

  useEffect(() => {
    if (pageNumber !== FIRSTPAGE) {
      setPageNumber(FIRSTPAGE);
    }
    if (canPageLoad) {
      let _searchObject = { ...searchObject };
      _searchObject.availabilityStatus = _searchObject.availabilityStatus.map(
        (x) => x.id
      );
      getInterviews(_searchObject);
    }
    if (isEmpty()) {
      setEnableClearFilters(true);
    } else {
      setEnableClearFilters(false);
    }
  }, []);

  function submitSearch() {
    let _searchObject = { ...searchObject };
    if (_searchObject.businessAreas?.length > 0)
      _searchObject.businessAreas = _searchObject.businessAreas.map(
        (item) => item.id
      );
    if (_searchObject.tags?.length > 0)
      _searchObject.tags = _searchObject.tags.map((item) => item.id);

    getInterviews(_searchObject);
    setIsFilterOpen(false);
  }
  useEffect(() => {
    if (canPageLoad) {
      let searchObject1 = {...searchObject}
      if (searchObject1.tags !== undefined) {
        searchObject1.tags = searchObject1.tags.map((x) => x.id);
      }
      getInterviews(searchObject1);
    }
  }, [pageNumber, pageSize, searchObject.orderby, searchObject.order]);

  function replacePreviousInterview(pageSize, pageNumber, _searchObject) {
    props
      .getInterviews(pageSize, pageNumber, _searchObject)
      .then((data) => {
        setInterview(data.page);
        if (props.setNumberOfResults) props.setNumberOfResults(data.total);
        SetTotalPages(Math.ceil(data.total / pageSize));
        setCanExport(data.canExport);
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("Something went wrong."));
      })
      .finally(() => {
        setIsInterviewsLoading(false);
      });
  }

  function getInterviews(_searchObject) {
    let searchObject1 = { ..._searchObject };
    if (searchObject1.availabilityStatus !== undefined) {
      searchObject1.availabilityStatus = _searchObject.availabilityStatus.map(
        (x) => x.id
      );
    }
    if (searchObject1.skills !== undefined) {
      searchObject1.skills = _searchObject.skills.map((x) => x.id);
    }

    props
      .getInterviews(pageSize, pageNumber, searchObject1)
      .then((data) => {
        setInterview(data.page);
        if (props.setNumberOfResults) props.setNumberOfResults(data.total);
        SetTotalPages(Math.ceil(data.total / pageSize));
        setCanExport(data.canExport);
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("Something went wrong."));
      })
      .finally(() => {
        setIsInterviewsLoading(false);
      });
  }

  function exportToFile(_format) {
    if (canExport) {
      let fileName = "";
      if (_format === format.excel) {
        fileName = `${t("Interviews")}_${new Date().toLocaleDateString()}.xlsx`;
      }

      let expectedResults = totalPages * pageSize;

      setListExportDownloadStatus({
        statusName: "downloading",
        errorCaught: false
      });
      let _searchObject = { ...searchObject };
      if (_searchObject.businessAreas?.length > 0)
        _searchObject.businessAreas = _searchObject.businessAreas.map(
          (item) => item.id
        );
      InterviewService.exportToFile(
        _searchObject,
        expectedResults,
        fileName,
        _format
      )
        .then(() =>
          setListExportDownloadStatus({
            statusName: "downloaded",
            errorCaught: false
          })
        )
        .catch((err) => {
          setListExportDownloadStatus((prevState) => ({
            ...prevState,
            errorCaught: true
          }));
          console.error(err);
          toast.error(t("Something went wrong"));
        })
        .finally(() =>
          setTimeout(
            () =>
              setListExportDownloadStatus((prevState) => ({
                ...prevState,
                statusName: "done"
              })),
            3000
          )
        );
    } else {
      showWarning(
        t(
          "The number of exported records exceeds the defined limit. Add search criteria to reduce the list to export."
        )
      );
    }
  }
  const [showTableEditor, setShowTableEditor] = useState(false);

  const history = useHistory();

  function onClickEditInterview(event, id) {
    event.stopPropagation();
    history.push(`/interview/createOrEdit/${id}`);
  }

  function onClickViewInterview(event, id) {
    event.stopPropagation();
    window.open(`/interview/view/${id}`).focus();
  }

  const clearFilters = () => {
    setSearchObject({ nameOrEmail: "", availabilityStatus: [], skills: [] });
    setIsFilterOpen(false);
    setSelectedFilters({});
    getInterviews({});
  };

  function isEmpty() {
    for (var prop in searchObject) {
      if (searchObject[prop] && prop !== "orderby" && prop !== "order")
        return true;
    }
    return false;
  }
  function removeFilter(key) {
    let _searchObject = { ...searchObject };
    if (key === "favorites") {
      _searchObject = { ..._searchObject, favorites: false };
    } else if (key === "recommended") {
      _searchObject = { ..._searchObject, recommended: false };
    } else if (key === "skills") {
      _searchObject = { ...searchObject, skills: [] };
    } else if (key === "availabilityStatus") {
      _searchObject = { ...searchObject, availabilityStatus: [] };
    } else {
      _searchObject = { ...searchObject, [key]: null };
    }
    setSearchObject(_searchObject);
    getInterviews(_searchObject);
  }

  function addFilter(filter) {
    setSelectedFilters({ ...selectedFilters, [filter.key]: filter.value });
  }

  function searchForm() {
    return (
      <InterviewListFilters
        searchObject={searchObject}
        setSearchObject={setSearchObject}
        addFilter={addFilter}
      />
    );
  }

  return (
    <>
      <div className="d-flex row">
        <div
          className="col text-end text-end-interview"
          style={{
            position: "absolute",
            left: "85%",
            top: "99px",
            width: "auto"
          }}
        >
          {interview.length > 0 &&
            userInformation.permissions.Export_Interview && (
              <InterviewExportButton
                exportToFile={exportToFile}
                isButtonDisabled={
                  listExportDownloadStatus.statusName === "downloading"
                }
              />
            )}
        </div>
      </div>
      <SideDrawerSearch
        searchForm={searchForm}
        onClearFilters={clearFilters}
        onRemoveFilter={removeFilter}
        filterObject={selectedFilters}
        setFilterObject={setSelectedFilters}
        submitSearch={submitSearch}
      >
        <div className="table-wrap interview-list">
          <hr style={{ width: "auto", marginTop: "0px" }} />
          {isInterviewsLoading ? (
            <>
              <table>
                <thead>
                  <SortedHeader
                    searchObject={searchObject}
                    setSearchObject={setSearchObject}
                    headers={headers}
                    setHeaders={setHeaders}
                    tableName="Interviews"
                  />
                </thead>
              </table>
            </>
          ) : (
            <>
              <table className="table-responsive">
                <thead className="col-md-24">
                  <SortedHeader
                    searchObject={searchObject}
                    setSearchObject={setSearchObject}
                    setHeaders={setHeaders}
                    headers={headers}
                    tableEditor={() => setShowTableEditor(true)}
                  />
                </thead>
                <tbody>
                  {interview.map((interview) => {
                    let candidateStateColor = "";
                    let tooltip = "";
                    if (interview.candidateState === "NotToHire") {
                      candidateStateColor = "bl-red";
                      tooltip = t("Manager interest do not hire");
                    } else if (interview.candidateState === "Direct_Hiring") {
                      candidateStateColor = "bl-orange";
                      tooltip = t("Manager interest direct hiring");
                    } else if (interview.candidateState === "ExistsProposal") {
                      candidateStateColor = "bl-lightgreen";
                      tooltip = "pre-proposal or proposal exists";
                    }

                    return (
                      <tr
                        key={interview.id}
                        onClick={(event) => {
                          userInformation.permissions.Create_Edit_Interview &&
                            onClickViewInterview(event, interview.id);
                        }}
                        className={
                          interview.candidateState === "NotToHire"
                            ? "bg-notHiring"
                            : ""
                        }
                      >
                        {" "}
                        <td
                          title={t(tooltip)}
                          className={`candidate-state ${candidateStateColor}`}
                          style={{ width: "1%" }}
                        ></td>
                        {headers.map((header) => {
                          if (header.key === "rating") {
                            return (
                              <td
                                className="rating text-truncate"
                                style={{ width: "4%", paddingLeft: "5px" }}
                              >
                                {interview.rating}
                              </td>
                            );
                          } else if (header.key === "name") {
                            return (
                              <td
                                className="name text-truncate"
                                title={
                                  t(interview.emailAddress) +
                                  " / " +
                                  interview.phoneNumber
                                }
                                style={{ width: "25%", paddingLeft: "5px" }}
                              >
                                {!interview.isFinalized ? (
                                  <IconExclamation
                                    title={t("Incomplete Interview")}
                                    style={{ marginRight: "7px" }}
                                  />
                                ) : interview.isFinalized &&
                                  interview.type === 2 ? (
                                  <ScreenCallIcon
                                    title={t("Screen Call")}
                                    style={{
                                      fill: "black",
                                      marginRight: "7px"
                                    }}
                                  />
                                ) : (
                                  <div></div>
                                )}
                                {interview.name}
                              </td>
                            );
                          } else if (header.key === "techArea") {
                            return (
                              <td
                                className="role text-truncate"
                                title={interview.techArea}
                                style={{ width: "12%", paddingLeft: "5px" }}
                              >
                                {t(interview.techArea)}
                              </td>
                            );
                          } else if (header.key === "techRole") {
                            return (
                              <td
                                className="role text-truncate"
                                title={interview.techRole}
                                style={{ width: "12%", paddingLeft: "5px" }}
                              >
                                {t(interview.techRole)}
                              </td>
                            );
                          } else if (header.key === "availability") {
                            return (
                              <td
                                className="role text-truncate"
                                title={interview.availability}
                                style={{ width: "7%", textAlign: "center" }}
                              >
                                {t(interview.availability)}
                              </td>
                            );
                          } else if (header.key === "salaryExpected") {
                            return (
                              <td
                                style={{
                                  width: "5%",
                                  textAlign: "right",
                                  paddingRight: "10px"
                                }}
                              >
                                {interview.salaryExpected !== null &&
                                  `${
                                    interview.salaryExpected.toFixed(0) +
                                    " " +
                                    interview.monetarySalaryExpected
                                  }`}
                              </td>
                            );
                          } else if (header.key === "managerName") {
                            return (
                              <td
                                className="manager text-truncate"
                                title={interview.managerName}
                                id="managerName"
                                style={{
                                  width: "10%",
                                  paddingLeft: "10px",
                                  paddingRight: "10px"
                                }}
                              >
                                {interview.managerName}
                              </td>
                            );
                          } else if (header.key === "needDocumentation") {
                            return (
                              <td
                                className=""
                                title={interview.needDocumentation}
                                style={{ width: "3%" }}
                              >
                                {interview.needDocumentation && (
                                  <img
                                    src={IconValid}
                                    alt="valid"
                                    title={t("need")}
                                  />
                                )}
                              </td>
                            );
                          } else if (header.key === "skills") {
                            return (
                              <td
                                className="phone text-truncate"
                                title={interview.skills}
                                style={{ width: "23%", paddingLeft: "5px" }}
                              >
                                {interview.skills.join(", ")}
                              </td>
                            );
                          } else if (header.key === "englishLevel") {
                            return (
                              <td
                                className="phone text-truncate  text-center"
                                style={{
                                  paddingLeft: "5px",
                                  paddingRight: "10px"
                                }}
                                title={t(interview.englishLevelDescription)}
                              >
                                {interview.englishLevel}
                              </td>
                            );
                          } else if (header.key === "spanishLevel") {
                            return (
                              <td
                                className="phone text-truncate  text-center"
                                style={{
                                  paddingLeft: "5px",
                                  paddingRight: "10px"
                                }}
                                title={t(interview.spanishLevel)}
                              >
                                {interview.spanishLevel}
                              </td>
                            );
                          } else if (header.key === "frenchLevel") {
                            return (
                              <td
                                className="phone text-truncate text-center"
                                style={{
                                  paddingLeft: "5px",
                                  paddingRight: "10px"
                                }}
                                title={t(interview.frenchLevel)}
                              >
                                {interview.frenchLevel}
                              </td>
                            );
                          } else if (header.key === "dutchLevel") {
                            return (
                              <td
                                className="phone text-truncate text-center"
                                style={{
                                  paddingLeft: "5px",
                                  paddingRight: "10px"
                                }}
                                title={t(interview.dutchLevel)}
                              >
                                {interview.dutchLevel}
                              </td>
                            );
                          }else if (header.key === "yearsExperience") {
                            return (
                              <td
                                className="phone text-truncate text-center"
                                style={{
                                  paddingLeft: "5px",
                                  paddingRight: "10px"
                                }}
                                title={t(interview.yearsExperience)}
                              >
                                {interview.yearsExperience}
                              </td>
                            );
                          } else if (header.key === "zone") {
                            return (
                              <td
                                className="phone text-truncate"
                                title={t(interview.zone)}
                                style={{ width: "5%", paddingLeft: "5px" }}
                              >
                                {interview.zone}
                              </td>
                            );
                          } else if (header.key === "currentLocation") {
                            return (
                              <td
                                className="phone text-truncate"
                                title={t(interview.currentLocation)}
                                style={{ width: "5%", paddingLeft: "5px" }}
                              >
                                {interview.currentLocation}
                              </td>
                            );
                          } else if (header.key === "date") {
                            return (
                              <td
                                className="date text-truncate"
                                title={moment(interview.date).format(
                                  "DD-MM-YYYY"
                                )}
                                id="contactDate"
                                style={{
                                  width: "5%",
                                  paddingRight: "5px",
                                  paddingLeft: "5px"
                                }}
                              >
                                {toDateString(interview.date)}
                              </td>
                            );
                          } else if (header.key === "numberOfInterviews") {
                            return (
                              <td style={{ width: "1%", paddingLeft: "10px" }}>
                                {interview.numberOfInterviews}
                              </td>
                            );
                          } else if (header.key === "actions") {
                            return (
                              <td
                                className="text-end"
                                style={{
                                  display: "flex",
                                  flexDirection: "row-reverse"
                                }}
                              >
                                {interview.docOnlineStatus !== null &&
                                interview.docOnlineStatus === "Expired" ? (
                                  <img
                                    src={GrayCircle}
                                    alt="expired"
                                    title={t("DocOnline expired.")}
                                    width="18px"
                                  />
                                ) : interview.docOnlineStatus === "New" ? (
                                  <img
                                    src={YellowCircle}
                                    alt="pending"
                                    title={t(
                                      "DocOnline pending submission by the candidate."
                                    )}
                                    width="18px"
                                  />
                                ) : interview.docOnlineStatus ===
                                  "Submitted" ? (
                                  <img
                                    src={GreenCircle}
                                    alt="submitted"
                                    title={t(
                                      "DocOnline submitted by the candidate."
                                    )}
                                    width="18px"
                                  />
                                ) : interview.docOnlineStatus ===
                                  "IA" ? (
                                  <img
                                    src={BlueCircle}
                                    alt="ia"
                                    title={t(
                                      "DocOnline generated by IA."
                                    )}
                                    width="18px"
                                  />
                                ) : (
                                  <></>
                                )}
                                {interview.favorite && (
                                  <img
                                    src={IconStar}
                                    alt="ico-ppl"
                                    title={interview.rating}
                                    width="18px"
                                    style={{
                                      verticalAlign: "central",
                                      marginLeft: "10px"
                                    }}
                                    className="me-2"
                                  />
                                )}{" "}
                                <div className="dropdown">
                                  <button
                                    className="action-button"
                                    type="button"
                                    id="export"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <img
                                      src={IconThreeDots}
                                      alt="threedots"
                                      title={t("Options")}
                                    />
                                  </button>
                                  <ul
                                    className="dropdown-menu adjust-dropdown"
                                    aria-labelledby="more"
                                  >
                                    <li>
                                      <a
                                        href="#!"
                                        className=" dropdown-item"
                                        onClick={(event) => {
                                          onClickViewInterview(
                                            event,
                                            interview.id
                                          );
                                        }}
                                        title={t("View")}
                                        data-bs-toggle="tooltip"
                                      >
                                        {t("Details")}
                                      </a>
                                    </li>
                                    {userInformation.permissions
                                      .Create_Edit_Interview && (
                                      <li>
                                        <a
                                          href="#!"
                                          className="dropdown-item"
                                          onClick={(event) => {
                                            onClickEditInterview(
                                              event,
                                              interview.id
                                            );
                                          }}
                                          title={t("Edit")}
                                          data-bs-toggle="tooltip"
                                        >
                                          {t("Edit")}
                                        </a>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </td>
                            );
                          }
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {interview.length === 0 && (
                <div className="table-message">{t("No interviews found.")}</div>
              )}
            </>
          )}
        </div>
        <div className="row">
          <div className="text-end">
            <Pagination
              totalPages={totalPages}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
              setPageSize={setPageSize}
            />
          </div>
        </div>
      </SideDrawerSearch>
      <DynamicTableEditor
        show={showTableEditor}
        setShow={setShowTableEditor}
        setColumns={changeColumns}
        tableName={"interviews"}
      />
    </>
  );
}
